import React from 'react';
import PropTypes from 'prop-types';
import './PreloaderOverlay.css';
import preloaderGif from '../../../imgs/preloader-bar.gif';

const PreloaderOverlay = ({ title, count, message }) => {
  return (
    <div className="preloader-overlay">
      <div className="preloader-overlay__contents">
        <img className="preloader-overlay__loading-bar" src={preloaderGif} alt="loading bar" />
        {(title || message) && (
          <div className="preloader-overlay__text-container">
            {title && (
              <p className="preloader-overlay__title">
                <span className="preloader-overlay__count">{count}</span> {title}
              </p>
            )}
            {message && <p className="preloader-overlay__message">{message}</p>}
          </div>
        )}
      </div>
    </div>
  );
};
PreloaderOverlay.propTypes = {
  message: PropTypes.string
}

export default PreloaderOverlay;